// hooks/useTruncatedHtml.js
import { useMemo } from 'react';

export function useTruncatedHtml(html, maxLength = 150, suffix = '...') {
  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const truncateHtmlPreserveTags = (html, maxLength = 150, suffix = '...') => {
    const div = document.createElement('div');
    div.innerHTML = html;
    let length = 0;
    let done = false;

    function traverse(node) {
      if (done) return null;

      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.nodeValue || '';
        const remaining = maxLength - length;

        if (text.length <= remaining) {
          length += text.length;
          return document.createTextNode(text);
        } else {
          done = true;
          return document.createTextNode(text.substring(0, remaining) + suffix);
        }
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false);
        for (let child of node.childNodes) {
          const truncated = traverse(child);
          if (truncated) clone.appendChild(truncated);
          if (done) break;
        }
        return clone;
      }

      return null;
    }

    const fragment = document.createDocumentFragment();
    for (let child of div.childNodes) {
      const truncated = traverse(child);
      if (truncated) fragment.appendChild(truncated);
      if (done) break;
    }

    const tempDiv = document.createElement('div');
    tempDiv.appendChild(fragment);
    return tempDiv.innerHTML;
  };

  return useMemo(() => {
    const plain = stripHtml(html);
    const isLong = plain.length > maxLength;
    const truncated = isLong ? truncateHtmlPreserveTags(html, maxLength, suffix) : html;

    return {
      isLong,
      truncatedHtml: truncated,
      fullHtml: html,
    };
  }, [html, maxLength, suffix]);
}
